import angular from 'angular';

const ngModule = angular.module('portainer.edge.react.components', []);

export const componentsModule = ngModule.name;
